import {
  createStyles,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useMemo } from 'react';
import { useDeployForm } from '../../Hooks/deploy';
import { PeerInChannel } from './PeerInChannel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: '1px solid #e0e0e0',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      height: 240,
      minWidth: 350,
    },
    listSection: {
      backgroundColor: 'inherit',
    },
    ul: {
      backgroundColor: 'inherit',
      padding: 0,
    },
  }),
);

interface ChannelPeerAdderProps {
  channelIndex: number;
}

export const ChannelPeerAdder: React.FC<ChannelPeerAdderProps> = ({
  channelIndex,
}) => {
  const { orgs, channels, setChannels } = useDeployForm();

  const channel = useMemo(() => channels?.[channelIndex], [
    channelIndex,
    channels,
  ]);

  const classes = useStyles();

  const handleAddPeer = useCallback(
    (org: IOrg, peer: IPeer) => () => {
      const newPeers = new Set(channel.peers[org.orgName]);

      newPeers.add(peer.value);
      channel.peers = {
        ...channel.peers,
        [org.orgName]: Array.from(newPeers),
      };

      channels[channelIndex] = channel;

      setChannels([...channels]);
    },
    [channel, channelIndex, channels, setChannels],
  );

  return (
    <Grid container direction="row" spacing={10}>
      <Grid direction="column" container item xs={5}>
        <Typography variant="subtitle2">Peers Available</Typography>
        <List className={classes.root} subheader={<li />}>
          {orgs.map((org, index) => {
            // const isOrderer = !org.peers.some((peer) => peer.opts?.peer);
            // console.log('isOrderer', isOrderer);

            return (
              // <ListSubheader>{org.orgName}</ListSubheader>
              <>
                <li className={classes.listSection}>
                  <ul className={classes.ul}>
                    <ListSubheader>{org.orgName}</ListSubheader>
                    {org.peers
                      // .filter(
                      //   (peer) =>
                      //     channel?.peers &&
                      //     !Object.values(channel.peers)
                      //       .flat()
                      //       .includes(peer.value),
                      // )
                      .map((peer) => {
                        const labelId = `checkbox-list-label-${org.id}`;

                        return (
                          <ListItem key={org.id} role={undefined} dense>
                            <ListItemText
                              id={labelId}
                              primary={`${peer.value}`}
                            />

                            <ListItemSecondaryAction>
                              <Tooltip
                                title={peer.opts?.peer ? '' : 'No Peer'}
                                placement="top"
                              >
                                <span>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    edge="end"
                                    onClick={handleAddPeer(org, peer)}
                                    disabled={!peer.opts?.peer}
                                  >
                                    <AddIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </ListItemSecondaryAction>
                          </ListItem>
                        );
                      })}
                  </ul>
                </li>
              </>
            );
          })}
        </List>
      </Grid>

      <Grid direction="column" container item xs={5}>
        <PeerInChannel channelIndex={channelIndex} />
      </Grid>
    </Grid>
  );
};
